import React, { Suspense, lazy } from 'react';
import { RouteObject } from 'react-router';
import ProcessingModal from './Components/ProcessingModal';
import NotFoundPage from './Pages/NotFoundPage';

const Loader = (Component: any) => (props: any) => (
  <Suspense fallback={<ProcessingModal openModal={true} processType="processing" />}>
    <Component {...props} />
  </Suspense>
);

// Pages
const LandingHelp = Loader(lazy(() => import('./Pages/LandingHelp')));
const EnterPhoneNumber = Loader(lazy(() => import('./Pages/EnterPhoneNumber')));
const HelpSignatureDrawPad = Loader(lazy(() => import('./Pages/HelpSignatureDrawPad')));
const SignatureDrawPad = Loader(lazy(() => import('./Pages/SignatureDrawPad')));
const VerifyPhoneNumber = Loader(lazy(() => import('./Pages/VerifyPhoneNumber')));
const NationalCode = Loader(lazy(() => import('./Pages/NationalCode')));
const ShebaNumber = Loader(lazy(() => import('./Pages/ShebaNumber')));
const LocationInformation = Loader(lazy(() => import('./Pages/LocationInformation')));
const CompleteUserInfo = Loader(lazy(() => import('./Pages/CompleteUserInfo')));
const CompleteIdentityInformation = Loader(lazy(() => import('./Pages/CompleteIdentityInformation')));
const NationalCardSerialInformation = Loader(lazy(() => import('./Pages/NationalCardSerialInformation')));
const ConfirmInfo = Loader(lazy(() => import('./Pages/ConfirmInfo')));
const FieldPayment = Loader(lazy(() => import('./Pages/FieldPayment')));
const NoPayment = Loader(lazy(() => import('./Pages/NoPayment')));
const InformationConfirmed = Loader(lazy(() => import('./Pages/InformationConfirmed')));
const InformationWaiting = Loader(lazy(() => import('./Pages/InformationWaiting')));
const NoFaceMatching = Loader(lazy(() => import('./Pages/NoFaceMatching')));
const FaceRecognitionRecording = Loader(lazy(() => import('./Pages/FaceRecognitionRecording')));
const TakePictureNationalCardFront = Loader(lazy(() => import('./Pages/TakePictureCamera/NationalCardFront')));
const TakePictureNationalCardBack = Loader(lazy(() => import('./Pages/TakePictureCamera/NationalCardBack')));
const TakePictureSignature = Loader(lazy(() => import('./Pages/TakePictureCamera/Signature')));
const VideoConfirmed = Loader(lazy(() => import('./Pages/VideoConfirmed')));
const Otp = Loader(lazy(() => import('./Pages/landing/OtpPage')));
const UserInformation = Loader(lazy(() => import('./Pages/landing/UserInformationPage')));
const UserLocation = Loader(lazy(() => import('./Pages/landing/UserLocation')));
const DynamicLandingPage = Loader(lazy(() => import('./Components/Widgets/DynamicLanding')));
const SuccessPaymentPage = Loader(lazy(() => import('./Pages/landing/SuccessPayment')));
const SuccessAuthentication = Loader(lazy(() => import('./Pages/landing/SuccessAuthentication')));
const BankCard = Loader(lazy(() => import('./Pages/landing/BankCard')));
const DivarQuestion = Loader(lazy(() => import('./Pages/landing/divarQuestion')));
const SuccessAuthenticationFlow = Loader(lazy(() => import('./Pages/landing/SuccessAuthenticationFlow')));
const BirthDate = Loader(lazy(() => import('./Pages/BirthDate')));
const PostalCode = Loader(lazy(() => import('./Pages/PostalCode')));
const PlateNumber = Loader(lazy(() => import('./Pages/PlateNumber')));
const CarInformation = Loader(lazy(() => import('./Pages/CarInformation')));
const LicensePersonalityType = Loader(lazy(() => import('./Pages/LicensePersonalityType')));
const LicensePersonalityInput = Loader(lazy(() => import('./Pages/LicensePersonalityInput')));
const ConfirmLicensePersonalityInfo = Loader(lazy(() => import('./Pages/ConfirmLicensePersonalityInfo')));
const GetBasicInfo = Loader(lazy(() => import('./Pages/GetBasicInfo')));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <LandingHelp />,
  },
  {
    path: '/landing',
    element: <DynamicLandingPage />,
  },
  {
    path: '/help-signature-draw-pad',
    element: <HelpSignatureDrawPad />,
  },
  {
    path: '/signature-draw-pad',
    element: <SignatureDrawPad />,
  },
  {
    path: '/enter-phone-number',
    element: <EnterPhoneNumber />,
  },
  {
    path: '/verify-phone-number',
    element: <VerifyPhoneNumber />,
  },
  {
    path: '/national-code',
    element: <NationalCode />,
  },
  {
    path: '/sheba-number',
    element: <ShebaNumber />,
  },
  {
    path: '/location-information',
    element: <LocationInformation />,
  },
  {
    path: '/complete-user-info',
    element: <CompleteUserInfo />,
  },
  {
    path: '/complete-identify-information',
    element: <CompleteIdentityInformation />,
  },
  {
    path: '/national-card-serial',
    element: <NationalCardSerialInformation />,
  },
  {
    path: '/confirm-info',
    element: <ConfirmInfo />,
  },
  {
    path: '/success-payment',
    element: <SuccessPaymentPage />,
  },
  {
    path: '/field-payment',
    element: <FieldPayment />,
  },
  {
    path: '/no-payment',
    element: <NoPayment />,
  },
  {
    path: '/information-confirmed',
    element: <InformationConfirmed />,
  },
  {
    path: '/information-waiting',
    element: <InformationWaiting />,
  },
  {
    path: '/no-face-matching',
    element: <NoFaceMatching />,
  },
  {
    path: '/face-recognition-recording',
    element: <FaceRecognitionRecording />,
  },
  {
    path: '/take-picture-national-card-front',
    element: <TakePictureNationalCardFront />,
  },
  {
    path: '/take-picture-national-card-back',
    element: <TakePictureNationalCardBack />,
  },
  {
    path: '/take-picture-signature',
    element: <TakePictureSignature />,
  },
  {
    path: '/video-confirmed',
    element: <VideoConfirmed />,
  },
  {
    path: '/otp-page',
    element: <Otp />,
  },
  {
    path: '/user-information',
    element: <UserInformation />,
  },
  {
    path: '/user-location-page',
    element: <UserLocation />,
  },
  {
    path: '/divar-success-payment',
    element: <SuccessPaymentPage />,
  },
  {
    path: '/success-authentication',
    element: <SuccessAuthentication />,
  },
  {
    path: '/bank-card',
    element: <BankCard />,
  },
  {
    path: '/divar-process',
    element: <DivarQuestion />,
  },
  {
    path: '/success-authentication-flow',
    element: <SuccessAuthenticationFlow />,
  },
  {
    path: '/not-found-page',
    element: <NotFoundPage />
  },
  {
    path: '/plate-number',
    element: <PlateNumber />
  },
  {
    path: '/car-info',
    element: <CarInformation />
  },
  {
    path: '/birth-date',
    element: <BirthDate />
  },
  {
    path: '/postal-code',
    element: <PostalCode />
  },
  {
    path: '/license-personality-type',
    element: <LicensePersonalityType />
  },
  {
    path: '/license-personality-input',
    element: <LicensePersonalityInput />
  },
  {
    path: '/license-personality-info',
    element: <ConfirmLicensePersonalityInfo />
  },
  {
    path: '/get-basic-info',
    element: <GetBasicInfo />
  },
];

export default routes;
